import { IExecutarETL } from "../../../Interfaces/Geral/ExecutarETL/ExecutarETLInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarExecucoesManuaisETLService() {
    return Service(
        Axios.get<Array<IExecutarETL>>(
            `/automacao/etlconfig/listarexecucoesmanuais`
        )
    );
}

export async function VoltarDataETLService() {
    return Service(Axios.post(`/automacao/etlconfig/voltardataetl`));
}
